/**
 * ArrowLeft – SVG icon.
 */
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Left arrow with configurable size and color. */
export default function ArrowLeftIcon({
  width = 31,
  height = 50,
  color = '#FFF',
}: IArrow) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width * Screen.widthRatio}`}
      height={`${height * Screen.widthRatio}`}
      viewBox={'0 0 31 50'}
    >
      <path
        fill={color}
        fillRule='evenodd'
        stroke={color}
        d='M30.2521 1.01815C31.3467 2.26198 31.2257 4.15761 29.9819 5.25218L7.54113 25L29.9819 44.7479C31.2257 45.8425 31.3467 47.7381 30.2521 48.9819C29.1576 50.2257 27.2619 50.3467 26.0181 49.2522L1.01812 27.2522C0.370903 26.6826 0 25.8622 0 25C0 24.1379 0.370903 23.3174 1.01812 22.7479L26.0181 0.747897C27.2619 -0.346667 29.1576 -0.225669 30.2521 1.01815Z'
      />
    </svg>
  );
}
